import { render, staticRenderFns } from "./paytradeall.vue?vue&type=template&id=35d390d6&"
import script from "./paytradeall.vue?vue&type=script&lang=js&"
export * from "./paytradeall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports